<template>
	<section class="card card-accounts active">
		<h2>rachunki</h2>

		<div class="user-env">
			<p class="lead">{{ userData.firstName }} {{ userData.lastName }}</p>
			<p>Status: Klient {{ userData.clientType }}</p>
			<p>{{ userData.email }} | {{ userData.mobilePhone }}</p>
		</div>
		<div class="clearfix"></div>
		<accounts-form />

		<div
			v-if="
				getHost !== domains.mbankHost &&
				!(getCurrentUser && getCurrentUser.sso && getCurrentUser.mt)
			"
			class="footer-links"
		>
			<!-- <router-link to="/MyFx" class="btn btn-secondary"
				>moje dane</router-link
			> -->
			<a
				v-if="!userData.isCompany"
				href="#"
				rel="noopener noreferrer"
				class="btn btn-secondary text-green"
				style="font-size: 15px"
				@click.prevent="checkIfCanEdit('/MyFx')"
				>moje dane</a
			>
			<router-link
				v-if="!userData.isCompany"
				to="/Pit"
				class="btn btn-secondary"
				>PIT</router-link
			>
			<router-link to="/Mifid" class="btn btn-secondary"
				>ankieta MIFID</router-link
			>
		</div>
		<div v-else class="footer-links">
			<a
				href="#"
				@click.prevent="logoutAndRedirect(getMyDataUrl)"
				rel="noopener noreferrer"
				class="btn btn-secondary"
				>moje dane</a
			>
			<router-link
				v-if="!userData.isCompany"
				to="/Pit"
				class="btn btn-secondary"
				>PIT</router-link
			>
			<router-link to="/Mifid" class="btn btn-secondary"
				>ankieta MIFID</router-link
			>
		</div>
	</section>
</template>

<script>
import AccountsForm from '@/views/dashboard/partial/_AccountsForm';
import { mapGetters } from 'vuex';

export default {
	components: {
		AccountsForm,
	},
	data() {
		return {
			// zmiana wyświetlania logowania w zalezności od tego na jakiej domenie jest user - wartości powinny być takie jak zwraca API
			/* eslint-disable */
			domains: {
				mbankHost: MBANK_HOST,
				mforexHost: MFOREX_HOST,
			},
		};
	},
	computed: {
		...mapGetters([
			'getHost',
			'getRedirectUrlAfterLogon',
			'getMyDataUrl',
			'getPitUrl',
			'getDisableOpenNewClientAccount',
			'getMifidUrl',
			'getOpenNewAccountUrl',
			'getCurrentUser',
		]),
		userData() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
	},
	methods: {
		logoutAndRedirect(url) {
			this.$store.dispatch('logOut', {
				dontRedirect: true,
				redirectUrl: url,
			});
		},
		checkIfCanEdit(link) {
			if (this.$store.getters.getCanEditClientData) {
				this.$router.push(link);
			} else {
				this.$store.commit('setShowCanEditClientDataModal', true);
			}
		},
	},
};
</script>
